import React, { useEffect, useState } from 'react';
import './MemberStyle.css';
import InputField from '../components/InputField';
import { emMember } from '../model/emMember';
import MemberList from '../components/MemberList';
import { useNavigate } from 'react-router-dom';
import { AiFillDelete} from "react-icons/ai";

interface Props{
    loggedState: number;
    loggedID: String;
}

const Member = ({loggedState,loggedID}:Props) => {
  const [emMembers,setEmMembers] = useState<emMember[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [memberID, setMemberID] = useState('');
  const navigate = useNavigate();
    
    const back = () => {
        navigate("/MainPage");
    };
    
  useEffect(() => {
    ReadMember(-2,loggedID);
  }, []);

  const filteredMembers = emMembers.filter(member => 
    member.name.toLowerCase().includes(searchTerm.toLowerCase()) // Filter nach Name
  );

  const ReadMember = async (emID:number,loggedID:String) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadMember.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          emID,
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        console.log('Member vorhanden:', data);
        setEmMembers(data);
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen der Member:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
};
  
  const handleCheckboxChange = async (memberID:String, column:String, value:String) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateMember.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              //Einsatz => em_Einsätze
              memberID,
              column,
              value,
            }),
          });

          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            if(data.status === 'success'){
              ReadMember(-2,loggedID);
            }
            else{
              alert("Einsatzkraft konnte nicht aktualisiert werden");
            }
              
          } else {
            const data = await response.json();
            alert("Einsatzkraft konnte nicht aktualisiert werden");
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }   
  };

  const handleCheckboxChangeResInf = async (memberID:string,resInfID:string,name:string,value:string) => {
      if(resInfID === '0'){
        const userConfirmed = window.confirm("Wollen Sie den User für RescueInfo freischalten?")
        if(userConfirmed){
          setName(name);
          setMemberID(memberID);
          setShowEmailPopup(true); 
        }
      }
      else{
        const userConfirmed = window.confirm("Wollen Sie dem User wirklich den Zugang zu RescueInfo entziehen?")
        if(userConfirmed){
          deleteResInfFromDB(resInfID)
          updateResInf(memberID)
        }
      }
};

  const updateName = (id:number, field:string, value:string) => {
    setEmMembers((prevMembers) =>
      prevMembers.map((member) =>
        member.ID === id
          ? { ...member, [field]: value } // Update das Feld (activeMember oder agt)
          : member
      )
    );
  };

  const handleNameChange = async (memberID:String, value:String) => {
    const column = 'name'
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateMember.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze 
          memberID,
          column,
          value,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          ReadMember(-2,loggedID);
        }
        else{
          alert("Einsatzkraft konnte nicht aktualisiert werden");
        }
          
      } else {
        const data = await response.json();
        alert("Einsatzkraft konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   
  };

  const deleteMember = async (ID:number) => {
    try {
        const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteMember.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ID,
          }),
        });
  
        if (response.ok) {
          const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          if(data.status === 'success'){
            alert("Einsatzkraft wurde gelöscht");
            ReadMember(-2,loggedID)
          }
          else{
            alert("Einsatzkraft konnte gelöscht werden werden");
          }
            
        } else {
          const data = await response.json();
          console.error('Fehler beim lesen des Einsatz:', response.statusText);
          alert("Einsatzkraft konnte nicht aktualisiert werden");
        }
      } catch (error) {
        console.error('Fehler beim Request:', error);
      }   

};

const memberAdd = async (loggedID:String) => {
  try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddMember.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          alert("Einsatzkraft wurde angelegt");
          ReadMember(-2,loggedID)
        }
        else{
          alert("Einsatzkraft konnte nicht angelegt werden");
        }
          
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Einsatzkraft konnte nicht angelegt werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   

};

const AddMember = () => {
  memberAdd(loggedID)
  
};

const deleteMem = (id:number, resInfID:number) => {
  deleteMember(id)
  deleteResInfFromDB(String(resInfID))
};

const handleEmailSubmit = async (name:String,mail:String,memberID:String) => {
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddToRescueInfo.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        mail,
        memberID
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
      if(data.message === 'OK'){
        alert("RescueInfo wurde freigeschaltet");
        ReadMember(-2,loggedID)
        setShowEmailPopup(false)
        setMemberID('')
        setEmail('')
        setName('')
      }
      else{
        if(data.message === 'Die E-Mail Adresse ist breits registiert!'){
          alert("Die E-Mail Adresse ist breits registiert!");
        } else{
          alert("RescueInfo konnte nicht freigeschaltet werden");
        }
        
      }
        
    } else {
      const data = await response.json();
      console.error('Fehler beim lesen des Einsatz:', response.statusText);
      alert("RescueInfo konnte nicht freigeschaltet werden");
    }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};

const deleteResInfFromDB = async (resInfID:String) => {
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteRescueInfo.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        resInfID,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
      if(data.status === 'success'){

      }
      else{
        alert("RescueInfo konnte nicht freigeschaltet werden");
      }
        
    } else {
      const data = await response.json();
      console.error('Fehler beim lesen des Einsatz:', response.statusText);
      alert("RescueInfo konnte nicht freigeschaltet werden");
    }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};

const updateResInf = async (memberID:string) => {
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateRescInf.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        memberID,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
      if(data.message === 'OK'){
        ReadMember(-2,loggedID);
      }
      else{
        alert("RescueInfo konnte nicht abgeschaltet werden");
      }
        
    } else {
      const data = await response.json();
      console.error('Fehler beim lesen des Einsatz:', response.statusText);
      alert("RescueInfo konnte nicht abgeschaltet werden");
    }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};

  return (
    <div className="App" style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
      <div className="search-box-container">
            <div className="header">
                <h2>Einsatzkräfte-Verwaltung</h2>
                <button className="new-button" onClick={() => AddMember()}>Neue Einsatzkraft</button>
            </div>
            <div className="search-box">
                <label htmlFor="search">Suche:</label>
                <input 
                  type="text" 
                  id="search"  
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} // Überwachen der Eingabe
                />
            </div>
        </div>


      <table className="table">
        <thead className="table-header">
        <tr>
          <th className="col-1m">Aktiv</th>
          <th className="col-2m">Name</th>
          <th className="col-3m">AGT</th>
          <th className="col-4m">RescueInfo</th>
          <th className="col-5m"></th>
        </tr>
      </thead>
      <tbody>
        {filteredMembers.map((row) => (
          <tr key={row.ID}>
            <td className="col-1m">
                <input
                  type="checkbox"
                  checked={Number(row.activeMember) === 1}
                  onChange={(e) =>
                    handleCheckboxChange(String(row.ID), 'activeMember', String(e.target.checked))
                  }
                />
              </td>
              <td className="col-2m">
                <input
                  type="text"
                  value={row.name}
                  onChange={(e) => updateName(row.ID,'name', e.target.value)}
                  onBlur={(e) => handleNameChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                />
              </td>
            <td className="col-3m">
                <input
                  type="checkbox"
                  checked={Number(row.agt) === 1}
                  onChange={(e) =>
                    handleCheckboxChange(String(row.ID), 'agt', String(e.target.checked))
                  }
                />
              </td>
              <td className="col-4m">
              <input
                  type="checkbox"
                  checked={Number(row.resInfID) != 0}
                  onChange={(e) =>
                    handleCheckboxChangeResInf(String(row.ID),String(row.resInfID), String(row.name), String(e.target.checked))
                  }
                />
              </td>
              <td className="col-5m">
                <span className='icon' onClick={()=> deleteMem(row.ID,row.resInfID)}>
                    <AiFillDelete></AiFillDelete>
                </span>
              </td>
          </tr>
        ))}
      </tbody>
    </table>
      

      {/* Popup für E-Mail-Eingabe */}
      {showEmailPopup && (
        <div className="popup-overlay">
          <div className="email-popup">
            <h3>E-Mail Adress für RescueInfo Zugang eingeben:</h3>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-Mail eingeben"
            />
            <button onClick={() => handleEmailSubmit(name,email,memberID)}>Bestätigen</button>
            <button onClick={() => setShowEmailPopup(false)}>Abbrechen</button>
          </div>
        </div>
      )}



    </div>
  );
}

export default Member;
